import type { ReactNode } from 'react';

import { css } from '@sorare/css';

import { HeadlineXS } from '#src/atoms/typography/index.tsx';

type Props = {
  id: string;
  children: ReactNode;
  error?: boolean;
  required?: boolean;
};

const label = css`
  color: var(--c-onBase-primary);
  .error {
    font-weight: normal;
    color: var(--c-red-400);
  }
`;

export const FormLabel = ({ id, children, error, required = false }: Props) => {
  return (
    <HeadlineXS as="label" htmlFor={id} className={label}>
      {children} {!!required && '*'}{' '}
      {!!error && <span className="error">{error || null}</span>}
    </HeadlineXS>
  );
};
